module.exports = __webpack_public_path__ + "img/trans-stats.22c20803.svg";